<template>
  <div
    ref="dropAreaContainer"
    class="drop-area-container rounded-borders relative-position"
    :class="{ 'drop-area-container-border': bordered }"
    @dragenter.prevent
    @dragover.prevent
    @dragleave.prevent
    @drop.stop="ondrop"
  >
    <slot>
      <div class="drop-area text-center ellipsis q-pa-xs">
        {{ placeholder }}
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DropArea',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: 'Drop here...',
    },
    bordered: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['ondrop'],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    ondrop(e: DragEvent) {
      // console.log('DropArea ondrop', e);
      try {
        const data = e.dataTransfer?.getData('dnddata') ?? '';
        const dnddata = data ? JSON.parse(data) : e;

        // console.log('DropArea ondrop', dnddata);
        this.$emit('ondrop', dnddata);
      } catch (error) {
        console.error(`Error [${this.$options.name}]: `, error);
      }
    },
  },
});
</script>

<style lang="scss">
.drop-area-container {
  min-height: 32px;
  &.drop-area-container-border {
    border: 1px dashed $grey-3;
  }
  .drop-area {
    max-height: 100%;
    max-width: 100%;
    color: #9e9e9e;
  }
}
</style>
